/*
 * Javascript for address search
 */

var typingTimer;
var doneTypingInterval = 400;
var addresses;
var address_target = "address1";
var loading_html = $("<div></div>", {
	class: "p-3 text-center",
	id: "address_loading",
	html:
		'<i class="far fa-spinner fa-lg fa-pulse"></i><p class="mt-2 block text-sm">Searching</p>',
});

(function ($) {
	//If there is a form with has-afd="true" attribute then skip all
	if (!$('form[has-afd="true"]').length) {
		$(".address_search").each(function () {
			var this_input = $(this);
			this_input.keyup(function (e) {
				address_target = $(this).data("target");
				clearTimeout(typingTimer);
				if (this_input.val()) {
					typingTimer = setTimeout(doneTyping, doneTypingInterval);
				}
			});
		});

		$(".address_search").click(function () {
			address_target = $(this).data("target");
			if ($(".address_search").val()) {
				//If length is more than 3 characters
				if ($(".address_search").val().length > 3) {
					doneTyping();
				}
			}
		});

		$(document).on("click", "#findaddress", function (e) {
			e.preventDefault();
			doneTyping();
			return false;
		});

		$(document).on("click", ".manual-address", function (e) {
			e.preventDefault();
			address_target = $(this).data("address-target");
			var target = $("#" + address_target + "-fulladdress");
			target.removeClass("hidden");

			//Go through all the inputs in target and ensure they are not readonly
			target.find("input").each(function () {
				$(this).removeAttr("readonly");
			});

			//Find py3_areatext in target and set value to ''
			target.find("#py3_areatext").val("");
			target.find("#" + address_target + "_longitude").val("");
			target.find("#" + address_target + "_latitude").val("");

			return false;
		});

		function doneTyping() {
			address_search(
				".address_search[data-target=" + address_target + "]",
				".address-search-results[data-target=" + address_target + "]",
				"#address_status"
			);
		}

		function address_search(
			input_element,
			address_results,
			status_element,
			page
		) {
			loading_html.remove();

			var page = page || 0;

			var address = $(input_element).val().trim();

			var address_target = $(input_element).data("target");

			if (address != "") {
				// Remove any previous validation results
				if (page == 0) $(address_results).empty();

				// Create a loading message
				$(address_results).before(loading_html);

				//$(status_element).text("Searching addresses");

				// Country hard coded to GB for this example
				var country_code = "GB";
				// Create the URL to API including API key and encoded search term
				//var address_url = "https://api.afd.co.uk/v1/address/GBR/fastfind?serial=831382&password=yAakFjTR&fields=standard&MaxQuantity=20&format=json&lookup=" + encodeURIComponent(address);
				var address_url =
					"/actions/eauk-general/default/get-address?address=" +
					encodeURIComponent(address);

				// Call the API
				$.ajax({
					url: address_url,
				})
					.done(function (data) {
						if (data.Result == "-2") {
							loading_html.remove();
							$(address_results).text("No addresses found");
							$(
								".address-search-results-container[data-target=" +
									address_target +
									"]"
							).removeClass("hidden");
						} else {
							var results = data.Item;

							addresses = results;

							console.log('Loading, remove spinner 1');

							$("#address_loading").remove();

							if (results) {
								$.each(results, function (index, item) {
									const addressComponents = [
										item.Organisation,
										item.Property,
										item.Street,
										item.Locality,
										item.Town,
										item.PostalCounty,
										item.Postcode,
									];

									// Filter out undefined and empty values
									const filteredComponents = addressComponents.filter(
										(component) => component
									);

									// Join the components with ', ' separator
									const addressString = filteredComponents.join(
										", "
									);

									// Remove leading commas and multiple consecutive commas
									const optimizedAddressString = addressString
										.replace(/,+/g, ", ")
										.replace(/^, /, "");

									var address_string = optimizedAddressString;

									address_string = address_string.replaceAll(
										address,
										'<span class="font-bold">' +
											address +
											"</span>"
									);

									var address_result =
										'<li data-address="' +
										index +
										'" class="cursor-pointer px-5 py-2 rounded-lg hover:bg-gray-50"><h3 class="text-gray-900 font-medium text-md mb-0">' +
										address_string +
										"</h3></li>";

									$(address_results).append(address_result);
									$(
										".address-search-results-container[data-target=" +
											address_target +
											"]"
									).removeClass("hidden");
								});

								loading_html.remove();
							} else {
								$(address_results).text("No addresses found");
							}
						}
					})
					.fail(function (error) {
						loading_html.remove();
						$(status_element).text("Error occurred");
						$(address_results).text("Error occurred");
						// Triggered if API does not return HTTP code between 200 and 399
						// More info - https://developers.alliescomputing.com/postcoder-web-api/error-handling
					});
			} else {
				// Could show an "Address search term is required" message here
			}
		}

		$(document).click(function () {
			$(".address-search-results-container").addClass("hidden");
		});
		$(
			".address-search, .address-search-results-container[data-target=" +
				address_target +
				"]"
		).click(function (e) {
			$(
				".address-search-results-container[data-target=" +
					address_target +
					"]"
			).removeClass("hidden");
		});

		$(document).on("click", ".address-search-results li", function () {
			var target = $(this).parent().parent().data("address")
				? $(this).parent().parent().data("address")
				: "address1";

			var addressId = $(this).data("address");

			$(".address-search-items #" + address_target + "_latitude").val(
				addresses[addressId].Latitude || ""
			);
			$(".address-search-items #" + address_target + "_longitude").val(
				addresses[addressId].Longitude || ""
			);

			if (address_target == "address1") {
				$(".address-search-items #py3_areatext").val(
					addresses[addressId].EERName || ""
				);
			}

			$(".address-search-items #" + address_target + "_name").val(
				addresses[addressId].Organisation || ""
			);

			//If addresses[addressId].Organisation is not empty
			if (!addresses[addressId].Organisation) {
				$(".address-search-items #" + address_target + "_name")
					.parent()
					.addClass("hidden");
			}

			$(".address-search-items #" + address_target + "_line1").val(
				addresses[addressId].Property || ""
			);

			$(".address-search-items #" + address_target + "_line2").val(
				addresses[addressId].Street || ""
			);

			$(".address-search-items #" + address_target + "_line3").val(
				addresses[addressId].Locality || ""
			);

			$(".address-search-items #" + address_target + "_city").val(
				addresses[addressId].Town || ""
			);

			$(".address-search-items #" + address_target + "_county").val(
				addresses[addressId].PostalCounty || ""
			);
			$(".address-search-items #" + address_target + "_postalcode").val(
				addresses[addressId].Postcode || ""
			);

			$(".address-search-results-container").addClass("hidden");

			// Get the current scroll position
			var scrollPosition =
				window.pageYOffset || document.documentElement.scrollTop;

			$("#" + address_target + "-fulladdress").removeClass("hidden");
			$("#" + address_target + "-fulladdress")
				.find("input")
				.each(function () {
					$(this).removeAttr("readonly");
				});

			/*if (updateAddressMapWithCoordinates) {
				// Calculate the new height of the displayed block
				var newBlockHeight = $(
					"#" + address_target + "-fulladdress"
				).height(); // This gets the computed height, excluding padding and border

				// Get the original scroll position
				var originalScrollPosition = $(window).scrollTop();

				// Calculate the new scroll position
				var newScrollPosition = originalScrollPosition + newBlockHeight;

				// Scroll to the new calculated position
				$(window).scrollTop(newScrollPosition);

				updateAddressMapWithCoordinates(
					parseFloat(addresses[addressId].Latitude),
					parseFloat(addresses[addressId].Longitude)
				);
			}*/
		});

		var fields = [
			address_target + "_name",
			address_target + "_line1",
			address_target + "_line2",
			address_target + "_line3",
			address_target + "_city",
		];

		fields.forEach(function (fieldName) {
			var inputField = document.getElementById(fieldName);
			if (inputField) {
				inputField.addEventListener("keyup", function () {
					var currentValue = inputField.value;
					var formattedValue =
						currentValue.charAt(0).toUpperCase() +
						currentValue.slice(1);
					inputField.value = formattedValue;
				});
			}
		});

		//Find target_postalcode and make whole input uppercase
		var inputField = document.getElementById(
			address_target + "_postalcode"
		);
		if (inputField) {
			inputField.addEventListener("keyup", function () {
				var currentValue = inputField.value;
				var formattedValue = currentValue.toUpperCase();
				inputField.value = formattedValue;
			});
		}
	}
})(jQuery);
